var render = function () {
  var _vm$links, _vm$links2, _vm$links3, _vm$links4, _vm$links5, _vm$links6, _vm$links7, _vm$links8, _vm$links9, _vm$links0, _vm$links1, _vm$links10, _vm$links11, _vm$links12, _vm$links13, _vm$links14, _vm$links15;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.new_version === true ? _c('div', {
    staticClass: "btn-wrpr"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm$links = _vm.links) !== null && _vm$links !== void 0 && _vm$links.technical_guide ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": (_vm$links2 = _vm.links) === null || _vm$links2 === void 0 ? void 0 : _vm$links2.technical_guide
    }
  }, [_vm._v(" TECHNICAL GUIDE ")]) : _vm._e(), (_vm$links3 = _vm.links) !== null && _vm$links3 !== void 0 && _vm$links3.ruleset ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": (_vm$links4 = _vm.links) === null || _vm$links4 === void 0 ? void 0 : _vm$links4.ruleset
    }
  }, [_vm._v(" RULESET ")]) : _vm._e(), (_vm$links5 = _vm.links) !== null && _vm$links5 !== void 0 && _vm$links5.requirements ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "data-target": "#requirementsModal",
      "data-toggle": "modal"
    }
  }, [_vm._v(" REQUIREMENTS ")]) : _vm._e(), (_vm$links6 = _vm.links) !== null && _vm$links6 !== void 0 && _vm$links6.course_details ? _c('a', {
    staticClass: "btn-universal",
    attrs: {
      "target": "_blank",
      "href": (_vm$links7 = _vm.links) === null || _vm$links7 === void 0 ? void 0 : _vm$links7.course_details
    }
  }, [_vm._v(" COURSE DETAILS ")]) : _vm._e(), (_vm$links8 = _vm.links) !== null && _vm$links8 !== void 0 && _vm$links8.requirements ? _c('EventRequirements', {
    attrs: {
      "requirements": (_vm$links9 = _vm.links) === null || _vm$links9 === void 0 ? void 0 : _vm$links9.requirements
    }
  }) : _vm._e()], 1)]) : _c('ul', {
    staticClass: "list-inline mt-3 text-left events-btns"
  }, [(_vm$links0 = _vm.links) !== null && _vm$links0 !== void 0 && _vm$links0.guideline ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "btn-universal",
    attrs: {
      "target": "_blank",
      "href": (_vm$links1 = _vm.links) === null || _vm$links1 === void 0 ? void 0 : _vm$links1.guideline
    }
  }, [_vm._v(" TECHNICAL GUIDE ")])]) : _vm._e(), (_vm$links10 = _vm.links) !== null && _vm$links10 !== void 0 && _vm$links10.ruleset ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "btn-universal",
    attrs: {
      "target": "_blank",
      "href": (_vm$links11 = _vm.links) === null || _vm$links11 === void 0 ? void 0 : _vm$links11.ruleset
    }
  }, [_vm._v(" RULESET ")])]) : _vm._e(), (_vm$links12 = _vm.links) !== null && _vm$links12 !== void 0 && _vm$links12.requirements ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('button', {
    staticClass: "btn-universal border-0",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-target": "#requirementsModal",
      "data-toggle": "modal"
    }
  }, [_vm._v(" REQUIREMENTS ")]), _c('EventRequirements', {
    attrs: {
      "requirements": (_vm$links13 = _vm.links) === null || _vm$links13 === void 0 ? void 0 : _vm$links13.requirements
    }
  })], 1) : _vm._e(), (_vm$links14 = _vm.links) !== null && _vm$links14 !== void 0 && _vm$links14.course_details ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "btn-universal",
    attrs: {
      "target": "_blank",
      "href": (_vm$links15 = _vm.links) === null || _vm$links15 === void 0 ? void 0 : _vm$links15.course_details
    }
  }, [_vm._v(" COURSE DETAILS ")])]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }